import React from "react";
import AddLoteForm from "./AddLoteForm";

const AddLote = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Lote"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddLoteForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddLote;
